import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { MemberDetail } from '@/types/User'

import { AppeasementListColumns } from './Appeasements.data'
import { MobileAppeasement } from './MobileAppeasements'

export const Appeasements = ({ member }: { member: MemberDetail }) => {
  const { isTablet } = useMobile()

  const appeasements = member.appeasements || []

  const columns = useMemo(() => {
    return AppeasementListColumns
  }, [])

  return (
    <div className="flex w-full flex-col py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-lg leading-120">Appeasements</h2>
      </div>
      {isTablet ? (
        <>
          {(appeasements.length > 0 &&
            appeasements.map((appeasement, index) => <MobileAppeasement appeasement={appeasement} key={index} />)) || (
            <NoResults />
          )}
        </>
      ) : (
        <Table columns={columns as any} data={appeasements} />
      )}
    </div>
  )
}
